module.exports = __webpack_public_path__ + "img/keki_mistri.4eb56b1b.jpg";